import { FETCH_DEALERS_REQUEST } from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {string} State */
/** @type {string} */
const initialState = 'name,asc';

/**
 * @param {State} _
 * @param {import('modules/dealers/types').FetchDealersAction} action
 * @returns {State}
 */
const updateState = (_, { payload }) => payload.request.params.sort;

export default createReducer(initialState, {
  [FETCH_DEALERS_REQUEST]: updateState,
});
